<template>
  <div
    class="oai-ResearchTable"
    :class="{
      'oai-ResearchTable-animated': animated,
      'oai-ResearchTable-scrollable': scrollable
    }"
  >
    <div class="oai-ResearchTable_Inner">
      <DefineTemplate>
        <OnboardingAiResearchTableBody :rows="rows" />
      </DefineTemplate>

      <div v-if="scrollable" ref="scrollRef" class="oai-ResearchTable_Scroll">
        <ReuseTemplate />

        <AppVerticalScrollGradient :arrived-state="arrivedState" is-bottom-placement no-border />
      </div>

      <ReuseTemplate v-else />
    </div>
  </div>
</template>

<script setup>
import { createReusableTemplate, useScroll } from '@vueuse/core'
import { isString } from 'lodash'
import { nextTick, useTemplateRef, watch } from 'vue'

import AppVerticalScrollGradient from '@/components/ui/AppVerticalScrollGradient/AppVerticalScrollGradient'
import OnboardingAiResearchTableBody from '@/components/ui/onboarding-ai/OnboardingAiResearchTableBody'

const [DefineTemplate, ReuseTemplate] = createReusableTemplate()

defineOptions({
  name: 'OnboardingAiResearchTable'
})

const props = defineProps({
  rows: {
    type: Array,
    required: true,
    validator: rows => rows.every(row => row && isString(row.label) && isString(row.value))
  },

  animated: {
    type: Boolean,
    default: true
  },

  scrollable: {
    type: Boolean,
    default: false
  }
})

const scrollRef = useTemplateRef('scrollRef')
const { arrivedState, measure } = useScroll(scrollRef)

watch(
  () => props.rows,
  async () => {
    if (!props.scrollable) {
      return
    }

    await nextTick()
    measure()
  },
  { immediate: true, deep: true }
)
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/gradient-border';

.oai-ResearchTable {
  @extend %oai-gradient-border;

  position: relative;

  &-animated {
    @extend %oai-gradient-border--animated;
  }

  &-scrollable {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.oai-ResearchTable_Inner {
  @extend %oai-gradient-border-inner;

  position: relative;
  border-radius: calc(var(--ob-oai-gradient-border-radius) - var(--ob-oai-gradient-border-width));
}

.oai-ResearchTable-scrollable .oai-ResearchTable_Inner {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.oai-ResearchTable_Scroll {
  --gradient-color: var(--ob-oai-gradient-border-inner-bg, #{$white});

  flex: 1;
  overflow-y: auto;
}
</style>
